// CSS FILES
import "./pages/home/Home.css";
import "./pages/details/Details.css";
import "./pages/viewAll/ViewAll.css";
import "./pages/likedPage/LikedPage.css";
import "./pages/suggestProperty/SuggestProperty.css";
import "./pages/verifyProperty/VerifyProperty.css";
import "./pages/signUp/SignUp.css";
import "./pages/createLodge/CreateLodge.css";
import "./pages/missingPage/MissingPage.css";
import "./pages/updateLodge/UpdateLodge.css";
import "./pages/aboutUs/AboutUs.css";

import { lazy, Suspense } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

// IMPORT PAGES WITH CODE SPLITTING
const RequireAuth = lazy(() => import("./components/RequireAuth"));
const Home = lazy(() => import("./pages/home/Home"));
const Details = lazy(() => import("./pages/details/Details"));
const ViewAll = lazy(() => import("./pages/viewAll/ViewAll"));
const LikedPage = lazy(() => import("./pages/likedPage/LikedPage"));
const SuggestProperty = lazy(() =>
  import("./pages/suggestProperty/SuggestProperty"),
);
const VerifyProperty = lazy(() =>
  import("./pages/verifyProperty/VerifyProperty"),
);
const Auth = lazy(() => import("./pages/signUp/Auth"));
const CreateLodge = lazy(() => import("./pages/createLodge/CreateLodge"));
const MissingPage = lazy(() => import("./pages/missingPage/MissingPage"));
const UpdateLodge = lazy(() => import("./pages/updateLodge/UpdateLodge"));
const AboutUs = lazy(() => import("./pages/aboutUs/AboutUs"));
const Unauthorized = lazy(() => import("./pages/missingPage/Unauthorized"));

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "react-scroll-to-top";
import { DeletePopup } from "./components";
import { Spinner } from "./components";
import { useSelector } from "react-redux";
import { selectDeleteLodge } from "./features/slices/lodgeSlice";

const ROLES = {
  ADMIN: "admin",
  USER: "user",
};

function App() {
  const deleteState = useSelector(selectDeleteLodge);

  return (
    <>
      <ToastContainer theme="colored" pauseOnHover={false} autoClose={3000} />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<Auth />} />
          {/* <Route path="/our-team" element={<AboutUs />} /> */}

          {/* <Route
            element={<RequireAuth allowedRoles={[ROLES.ADMIN, ROLES.USER]} />}
          >
          </Route> */}
          <Route path="/view-all" element={<ViewAll />} />
          <Route path="/details" element={<Details />} />
          <Route path="/liked-lodges" element={<LikedPage />} />
          <Route path="/suggest" element={<SuggestProperty />} />
          <Route path="/verify-property" element={<VerifyProperty />} />

          {/* PROTECTED ROUTES */}
          <Route element={<RequireAuth allowedRoles={[ROLES.ADMIN]} />}>
            <Route path="/create-lodge" element={<CreateLodge />} />
            <Route path="/update-lodge" element={<UpdateLodge />} />
          </Route>

          {/* CATCH NON-EXISTING ROUTES */}
          <Route path="*" element={<MissingPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Route>
      </Routes>
      {deleteState?.delete && (
        <DeletePopup id={deleteState?.id} name={deleteState?.name} />
      )}

      <ScrollToTop
        smooth
        color="white"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--text-primary)",
        }}
      />
    </>
  );
}

function Layout() {
  return (
    <>
      <Suspense
        fallback={
          <div className="page-spinner">
            <Spinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
}

export default App;
